'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgMiscPinFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M12 2c-4.41 0-8 3.59-8 8 0 4.55 3.28 7.72 8 11.83 4.8-4.18 8-7.3 8-11.83 0-4.41-3.59-8-8-8Zm0 10.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Z" })
);

module.exports = SvgMiscPinFill;
//# sourceMappingURL=MiscPinFill.cjs.js.map
